/* eslint-disable react/prop-types */
import React from 'react';

const FilledIcon = ({ stroke = '#000000', ...props }) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="0.5"
      width="63"
      height="63"
      rx="7.5"
      fill="white"
      stroke={stroke === '#6930CA' ? stroke : '#A6A7B0'}
    />
    <rect
      x="25.2441"
      y="12.6409"
      width="31"
      height="31"
      rx="3.5"
      transform="rotate(20 25.2441 12.6409)"
      fill="#F4F6F9"
      stroke="#E6E9EE"
    />
    <rect
      x="28.7871"
      y="21.9116"
      width="15"
      height="13"
      rx="1"
      transform="rotate(20 28.7871 21.9116)"
      fill="#F4F6F9"
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="31.5195"
      y="26.0991"
      width="15"
      height="13"
      rx="1"
      transform="rotate(20 31.5195 26.0991)"
      fill="#F4F6F9"
      stroke={stroke}
      strokeWidth="2"
    />
    <circle
      cx="40.1074"
      cy="35.3435"
      r="1.5"
      transform="rotate(20 40.1074 35.3435)"
      fill={stroke}
    />
    <path
      d="M29.7277 22.254C28.3254 22.9658 27.6283 25.0518 33.416 26.7393"
      stroke={stroke}
      strokeWidth="2"
    />
    <path
      d="M24.7403 33.2081C24.2272 34.6177 22.3466 37.0193 27.7457 38.5587"
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="26.3105"
      y="30.8545"
      width="2"
      height="3"
      transform="rotate(20 26.3105 30.8545)"
      fill="#F4F6F9"
    />
    <path
      d="M24.2404 34.4056L27.0779 26.6096C27.2668 26.0906 27.8406 25.823 28.3596 26.0119L29.2993 26.354C29.8183 26.5429 30.0859 27.1167 29.897 27.6357L26.8188 36.0929C26.6299 36.6119 26.0558 36.8639 25.6197 36.525C25.1633 36.1701 24.7238 35.7162 24.3987 35.3408C24.176 35.0836 24.124 34.7253 24.2404 34.4056Z"
      fill={stroke}
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="16.4271"
      y="16.0441"
      width="31"
      height="31"
      rx="3.5"
      transform="rotate(10 16.4271 16.0441)"
      fill="#F4F6F9"
      stroke="#E6E9EE"
    />
    <rect
      x="21.526"
      y="24.5588"
      width="15"
      height="13"
      rx="1"
      transform="rotate(10 21.526 24.5588)"
      fill="#F4F6F9"
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="24.944"
      y="28.2083"
      width="15"
      height="13"
      rx="1"
      transform="rotate(10 24.944 28.2083)"
      fill="#F4F6F9"
      stroke={stroke}
      strokeWidth="2"
    />
    <circle
      cx="35.0078"
      cy="35.8207"
      r="1.5"
      transform="rotate(10 35.0078 35.8207)"
      fill={stroke}
    />
    <path
      d="M22.5114 24.7329C21.254 25.6774 20.9297 27.8528 26.9226 28.5096"
      stroke={stroke}
      strokeWidth="2"
    />
    <path
      d="M19.5008 36.3874C19.2403 37.8646 17.8053 40.5563 23.3897 41.1349"
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="20.6406"
      y="33.7959"
      width="2"
      height="3"
      transform="rotate(10 20.6406 33.7959)"
      fill="#F4F6F9"
    />
    <path
      d="M19.2177 37.6532L20.6584 29.4829C20.7543 28.939 21.2729 28.5758 21.8168 28.6717L22.8016 28.8453C23.3455 28.9412 23.7087 29.4599 23.6128 30.0038L22.05 38.8671C21.9541 39.411 21.4324 39.7589 20.9442 39.5008C20.433 39.2306 19.9213 38.8599 19.536 38.5466C19.272 38.3321 19.1587 37.9882 19.2177 37.6532Z"
      fill={stroke}
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="8.5"
      y="20.5"
      width="31"
      height="31"
      rx="3.5"
      fill="#F4F6F9"
      stroke="#E6E9EE"
    />
    <mask
      id="mask0_944_11862"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="20"
      width="32"
      height="32"
    >
      <rect x="8" y="20" width="32" height="32" fill="#2B2D42" />
    </mask>
    <g mask="url(#mask0_944_11862)">
      <mask
        id="mask1_944_11862"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="12"
        y="24"
        width="24"
        height="24"
      >
        <rect x="12" y="24" width="24" height="24" fill="#2B2D42" />
      </mask>
      <g mask="url(#mask1_944_11862)">
        <rect
          x="12.375"
          y="44.375"
          width="23.25"
          height="1.25"
          rx="0.625"
          fill={stroke}
          stroke={stroke}
          strokeWidth="0.75"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 32H20C18.8954 32 18 32.8954 18 34V44H14V32ZM28 32H20C21.1046 32 22 32.8954 22 34V44H26V34C26 32.8954 26.8954 32 28 32ZM30 44V34C30 32.8954 29.1046 32 28 32H34V44H30Z"
          fill={stroke}
        />
        <path
          d="M23.6574 26.1249C23.8787 26.0442 24.1213 26.0442 24.3426 26.1249L35.1356 30.0605C36.1864 30.4437 35.9115 32 34.793 32H13.207C12.0885 32 11.8136 30.4437 12.8644 30.0605L23.6574 26.1249Z"
          fill={stroke}
        />
      </g>
    </g>
  </svg>
);

export default FilledIcon;
